import '../../app.es6';
import angular from 'angular';

class AdminMemberListController {
  /* @ngInject */
  constructor (
    $rootScope, $scope, $sessionStorage, $location,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    // APIから取得した生徒が存在している場合：true
    // APIから取得した生徒が存在していない場合：false
    this.existenceFlg = true;

    this.getSchoolsSchoolIdMembers();

    Page.setTitle(this.Const.TITLE.memberListForAdmin);

    AdminMemberListController.$inject = ['$rootScope', '$scope',
                                        '$sessionStorage', '$location', 'commonApiFactory',
                                        'commonFactory', 'Const', 'Page'];
  }

  getSchoolsSchoolIdMembers () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    let membersParams = {
      schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID]
    };
    this.commonApiFactory.getAdminSchoolsSchoolIdMembers(membersParams)
    .then((result) => {
      this.memberList = [];
      if (result.length === 0) {
        this.existenceFlg = false;
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
        return;
      }
      result.forEach((member) => {
        let memberObj = {
          id: member.id,
          displayId: member.displayId,
          name: member.name,
          gender: this.commonFactory.getGenderName(member.gender),
          status: this.commonFactory.getPaddingZero(member.data.sensorRental, 2) + '-' +
                  this.commonFactory.getPaddingZero(member.data.user_type, 8) + '-' +
                  this.commonFactory.getPaddingZero(member.data.passwordStatus, 2)
        };
        this.memberList.push(memberObj);
      });
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      this.existenceFlg = false;
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
      console.log('error : ', error);
    });
  }

  generatePassword (member, event) {
    event.stopPropagation();
    this.$rootScope.targetId = member.id;
    this.$rootScope.password = this.commonFactory.createImterimPassword();
  }

  toMemberDetail (member) {
    this.$sessionStorage[this.Const.SSAPP_MEMBER_ID] = member.id;
    this.$sessionStorage[this.Const.SSAPP_USER_NAME] = member.name;
    this.$sessionStorage[this.Const.SSAPP_GENDER] = member.gender;
    this.$location.path('/staff/member_detail');
  }
}

angular.module('myApp').controller('AdminMemberListController', AdminMemberListController);



// WEBPACK FOOTER //
// ./app/components/admin-member-list/admin-member-list-controller.es6